import { render, staticRenderFns } from "./GoodsVideoShoot.vue?vue&type=template&id=3676bd0e&scoped=true&"
import script from "./GoodsVideoShoot.vue?vue&type=script&lang=js&"
export * from "./GoodsVideoShoot.vue?vue&type=script&lang=js&"
import style0 from "./GoodsVideoShoot.vue?vue&type=style&index=0&id=3676bd0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676bd0e",
  null
  
)

export default component.exports